import { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import LayoutTable from '../../../../Global/LayoutTable'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'
import {
  CREATE_FORM_FIELD_YUP_RULE,
  DELETE_FORM_FIELD_YUP_RULE,
  GET_ALL_FORM_FIELDS_YUP_RULES_BY_FIELD_ID,
  GET_ALL_YUP_RULES_AVAILABLE_FOR_FIELD,
} from '../../../../../graphql/Catalog/Forms/formFieldYupRules'

export const FormFieldYupRules = ({ fieldData, refetchMain }) => {
  const { showLoading, hideLoading } = useLoading()

  //STATES:
  const [data, setData] = useState({
    rows: [],
    count: null,
  })
  const [dataRules, setDataRules] = useState(null)
  const [ruleSeleted, setRuleSeleted] = useState('')

  //USEQUERY:
  const query = useQuery(GET_ALL_FORM_FIELDS_YUP_RULES_BY_FIELD_ID, {
    variables: { fieldId: fieldData?.id },
    fetchPolicy: 'no-cache',
  })

  const queryYupRulesAvailables = useQuery(
    GET_ALL_YUP_RULES_AVAILABLE_FOR_FIELD,
    {
      variables: { fieldId: fieldData?.id },
      fetchPolicy: 'no-cache',
    }
  )

  //USEMUTATION:
  const [createFormFieldTupRule] = useMutation(CREATE_FORM_FIELD_YUP_RULE)

  //EFFECTS:
  useEffect(() => {
    if (!query?.loading) {
      if (query?.error) {
        toastSweetAlert({
          mode: 'error',
          message: query?.error.message,
        })
      }

      let rows = []
      let count = 0

      rows = query?.data?.getAllFormFieldYupRulesByFieldId.map((item) => {
        return {
          id: item?.id,
          Descripcion: item.YupRuleOfField.description,
          Mensaje: item.YupRuleOfField.message,
        }
      })

      count = rows.length

      setData({ rows, count })
    }
  }, [query?.loading, query?.data, query?.error])

  useEffect(() => {
    if (!queryYupRulesAvailables?.loading) {
      if (queryYupRulesAvailables?.error) {
        toastSweetAlert({
          mode: 'error',
          message: queryYupRulesAvailables?.error.message,
        })
      }

      let list = []

      list = queryYupRulesAvailables?.data?.getAllYupRulesAvailableForField.map(
        (item) => {
          return {
            value: item?.id,
            label: item.description,
            message: item.message,
          }
        }
      )

      setDataRules(list)
    }
  }, [
    queryYupRulesAvailables?.loading,
    queryYupRulesAvailables?.data,
    queryYupRulesAvailables?.error,
  ])

  const processRefetchs = async () => {
    query.refetch()
    queryYupRulesAvailables.refetch()
    refetchMain()
  }

  const handleAddRuleToField = async () => {
    showLoading()
    try {
      if (ruleSeleted === '') {
        return toastSweetAlert({
          mode: 'error',
          message: 'Se debe seleccionar una de las reglas disponibles',
        })
      }

      await createFormFieldTupRule({
        variables: {
          fieldId: fieldData?.id,
          yupRuleId: parseInt(ruleSeleted),
        },
      })

      await processRefetchs()

      setRuleSeleted('')

      return toastSweetAlert({
        mode: 'ok',
        message: 'Se agrego regla con exito',
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <div className="row d-flex align-items-end">
        <div className="col-12 col-sm-6">
          {dataRules && (
            <>
              <label>
                <b>Reglas disponibles para asociar</b>
              </label>
              <select
                onChange={(e) => setRuleSeleted(e.target.value)}
                className={`form-control rounded-2`}
                value={ruleSeleted}
              >
                {dataRules.length > 0 ? (
                  <>
                    <option value="">Selecciona regla</option>
                    {dataRules.map((rule) => {
                      return (
                        <option key={rule.value} value={rule.value}>
                          {rule.label}
                        </option>
                      )
                    })}
                  </>
                ) : (
                  <option value="" disabled>
                    No hay reglas disponibles
                  </option>
                )}
              </select>
            </>
          )}
        </div>
        <div>
          <button
            className="btn btn-migrates btn-sm"
            onClick={() => handleAddRuleToField()}
          >
            Agregar regla a campo
          </button>
        </div>
      </div>

      <LayoutTable
        withCard={false}
        hideId
        hideAddNew={true}
        hideBtnEdit={true}
        hideDetails
        hideFilterBar
        data={data.rows}
        totalCount={data.count}
        exportImportButton={false}
        paginationServer={false}
        gql={DELETE_FORM_FIELD_YUP_RULE}
        requery={null}
        refetchFunctionQueries={() => processRefetchs()}
        noDataComponent=""
      />
    </>
  )
}

export default FormFieldYupRules
